"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.find = void 0;
exports.find = (iterable, iteratee) => {
    for (let i = 0; i < iterable.length; i++) {
        const item = iterable[i];
        if (iteratee(item, i, iterable)) {
            return item;
        }
    }
    return undefined;
};
//# sourceMappingURL=find.js.map